import {requests} from '../../services';
import {INVOICING_URL} from '../../utils/Endpoints';

export const InvoiceService = {
    getInvoices: (params: any) => requests.get(`${INVOICING_URL}`, params),
    togglePaid: (id: number) => requests.put(`${INVOICING_URL}/toggle/paid/${id}`, {}),
}
